import styled, { css } from 'styled-components';
import { Icon as StyledIcon } from '../../../icons';
import { hoverFocus, themeProp } from '../../../theme';
export const Icon = styled(StyledIcon) `
  && {
    position: absolute;
    top: 52%;
    right: 0.875rem;
    width: 1.25rem;
    height: 1.25rem;
    transform: translateY(-50%);
    transition: transform 0.2s ease-in-out;
    color: ${themeProp('colors.primary')};
    /* Makes the icon clickable for the expander */
    pointer-events: none;
  }
`;
export const Wrapper = styled.div `
  position: relative;

  ${hoverFocus `
    ${Icon} {
      transform: translateY(-40%);
    }
  `}
`;
export const Select = styled.select `
  width: 100%;
  height: ${themeProp('forms.inputHeight')};
  padding: ${themeProp('forms.inputPadding')};

  /* Makes room for the chevron down */
  padding-right: 2.5rem;
  border: ${themeProp('forms.inputBorder')};
  border-radius: ${themeProp('forms.inputBorderRadius')};
  box-shadow: ${themeProp('forms.inputShadow')};
  background-color: ${themeProp('colors.white')};
  appearance: none;
  cursor: pointer;
  font-size: 1rem;
  transition: border 300ms ease-in-out;

  &:focus {
    border-color: ${themeProp('colors.grayD30')};
  }

  &:disabled {
    background-color: ${themeProp('colors.grayL30')};
    transition: none;
    cursor: not-allowed;
  }

  &::-ms-expand {
    display: none;
  }

  ${(props) => props.isSingleOption &&
    css `
      background: ${props.theme.colors.grayL40};
      font-weight: bold;
      border: none;
      box-shadow: none;
    `}

  ${(props) => props.hasError &&
    css `
      border: 1px solid ${props.theme.colors.yellow};
      animation: ${props.theme.animations.shake} 0.3s linear;
    `}
`;
//# sourceMappingURL=custom-select.styles.js.map